'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feiseanna = require('../../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisAwardsController = function () {
  function FeisAwardsController(feis, $q, fFeisService, fEventService, $mdSidenav, metadata) {
    _classCallCheck(this, FeisAwardsController);

    this.feis = feis;
    this.roles = metadata.grants;
    this._svcs = { feis: feis, $q: $q, fFeisService: fFeisService, fEventService: fEventService, $mdSidenav: $mdSidenav };
    this._events = fEventService.for(this.feis.id);
    this.notInResults = false;
  }

  _createClass(FeisAwardsController, [{
    key: 'search',
    value: function search(filter) {
      if (!filter || filter === '') {
        return;
      }

      return this._svcs.$q.all([this._svcs.fFeisService.competitors(this.feis.id, { filter: filter }), this._events.all({ filter: filter })]).then(function (res) {
        var persons = res[0];
        var events = res[1];

        persons.forEach(function (p) {
          return p.$name = p.competitor + ' - ' + p.fname + ' ' + p.lname;
        });
        events.forEach(function (e) {
          return e.$isEvent = true;
        });

        return [].concat(events, persons);
      });
    }
  }, {
    key: 'get',
    value: function get(item) {
      var _this = this;

      this.results = null;
      this.notInResults = false;

      if (!item) {
        return;
      }

      if (item.$isEvent) {
        if (item.status !== 'RES') {
          this.notInResults = true;
          return;
        }

        return this._events.placements(item.id).then(function (scores) {
          return _this.results = scores.filter(function (r) {
            return r.score.placed === 1;
          });
        }).then(function (scores) {
          return scores.forEach(function (s) {
            return s.$name = s.competitor + ' - ' + s.fname + ' ' + s.lname;
          });
        });
      } else {
        return this._svcs.fFeisService.placementsForParticipant(this.feis.id, item.id).then(function (scores) {
          return _this.results = scores;
        });
      }
    }
  }, {
    key: 'toggleCollect',
    value: function toggleCollect(item, searchItem) {
      var eid;
      var pid;

      if (searchItem.$isEvent) {
        eid = searchItem.id;
        pid = item.id;
      } else {
        pid = searchItem.id;
        eid = item.id;
      }

      if (item.score.collected) {
        return this._events.collectAward(eid, pid);
      } else {
        return this._events.returnAward(eid, pid);
      }
    }
  }, {
    key: 'showPerson',
    value: function showPerson(person) {
      this.currentPerson = person;
      this._svcs.$mdSidenav('participant-sidenav').open();
    }
  }]);

  return FeisAwardsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.awards', ['ngMaterial', 'ui.router', 'ifeis.feiseanna', 'ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.awards', {
    url: '/awards',
    template: require('./tpl.html'),
    controller: FeisAwardsController,
    controllerAs: 'awards',
    ncyBreadcrumb: {
      label: 'Awards',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/awards/index.js
// module id = 541
// module chunks = 0